import { Switch } from 'components/Switch'
import { useDataForEnabledSwitch } from 'features/globalSetup/pages/Prebid/Bidders/EditBidderPage/pages/GeneralPage/hooks/useDataForEnabledSwitch'
import { useUpdateWorkspaceBidder } from 'features/globalSetup/pages/Prebid/Bidders/hooks/useUpdateWorkspaceBidder'
import { EnabledSwitchProps } from './types'

export const EnabledSwitch = ({
  accountType,
  bidderCode,
  enabled,
  id,
  status,
}: EnabledSwitchProps): React.JSX.Element => {
  const { disabled, tooltip } = useDataForEnabledSwitch({ accountType, status })
  const { checked, update } = useUpdateWorkspaceBidder({
    bidderCode,
    enabled,
    id,
  })

  return (
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={update}
      tooltip={tooltip}
      tooltipMode={'wrap'}
    />
  )
}
